/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelMenuOrderCheckResponse
 */
export interface CancelMenuOrderCheckResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CancelMenuOrderCheckResponse
     */
    isCancellable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CancelMenuOrderCheckResponse
     */
    hasCancelled: boolean;
}

/**
 * Check if a given object implements the CancelMenuOrderCheckResponse interface.
 */
export function instanceOfCancelMenuOrderCheckResponse(value: object): value is CancelMenuOrderCheckResponse {
    if (!('isCancellable' in value) || value['isCancellable'] === undefined) return false;
    if (!('hasCancelled' in value) || value['hasCancelled'] === undefined) return false;
    return true;
}

export function CancelMenuOrderCheckResponseFromJSON(json: any): CancelMenuOrderCheckResponse {
    return CancelMenuOrderCheckResponseFromJSONTyped(json, false);
}

export function CancelMenuOrderCheckResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelMenuOrderCheckResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isCancellable': json['isCancellable'],
        'hasCancelled': json['hasCancelled'],
    };
}

export function CancelMenuOrderCheckResponseToJSON(json: any): CancelMenuOrderCheckResponse {
    return CancelMenuOrderCheckResponseToJSONTyped(json, false);
}

export function CancelMenuOrderCheckResponseToJSONTyped(value?: CancelMenuOrderCheckResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isCancellable': value['isCancellable'],
        'hasCancelled': value['hasCancelled'],
    };
}

